import type { CableSpec } from "./cable-current";

/** Design bounds are useful for sizing without proving that a particular
 * branch actually carries their maximum. Keep that distinction in every UI
 * and diagnostic consumer of the shared spec. */
export function currentNeedsVerification(spec: CableSpec): boolean {
  return spec.currentBasis === "provisional-fallback" || !!spec.sourceAllocationDependent || !!spec.sizingVerificationRequired;
}

/** Design mode supplies an independent sustained envelope (including zero
 * for starting-only duty). Live mode already reports the active current and
 * must not be zeroed merely because the conductor can also serve a starter. */
export function sustainedCableCurrent(spec: CableSpec): number {
  return spec.sustainedCurrent ?? spec.continuous;
}
